import { render } from "./versionUnitTest.vue?vue&type=template&id=e8594572&scoped=true"
import script from "./versionUnitTest.js?vue&type=script&lang=js"
export * from "./versionUnitTest.js?vue&type=script&lang=js"

import "./versionUnitTest.vue?vue&type=style&index=0&id=e8594572&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8594572"]])

export default __exports__